export enum ProviderInfoStatus {
  Active = 'Active',
  Approved = 'Approved',
  ClassWallet = 'Class Wallet Pending',
  Denied = 'Denied',
  InPerson = 'In-person',
  InReview = 'In Review',
  NeedsResubmission = 'Needs Resubmission',
  NotStarted = 'Not Started',
  OnHold = 'On Hold',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Review = 'Review',
  Suspended = 'Suspended',
  UnderReview = 'Under Review',
  Verified = 'Verified'
}